export default [
    {
      path: '/building',
      name: 'building',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/main.vue')
    },
    {
      path: '/building/business',
      name: 'building_business',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/business.vue')
    },
    {
      path: '/building/web_720',
      name: 'building_web_720',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/web_720/main.vue')
    },
    {
      path: '/building/img_preview',
      name: 'building_img_preview',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/img_preview/main.vue')
    },
    {
      path: '/building/planar_graph',
      name: 'building_planar_graph',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/planar_graph/main.vue')
    },
    {
      path: '/building/event',
      name: 'building_event',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/event/main.vue')
    },
    {
      path: '/building/info',
      name: 'building_info',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/info/main.vue')
    },
    {
      path: '/building/comments',
      name: 'building_comments',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/comments/main.vue')
    },
    {
      path: '/building/comments/add',
      name: 'building_comments_add',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/comments/add/main.vue')
    },
    {
      path: '/building/sunlight',
      name: 'building_sunlight',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/sunlight/main.vue')
    },
    {
      path: '/building/price',
      name: 'building_price',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/price/main')
    },
    {
      path: '/building/price_detail',
      name: 'building_price_detail',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/price_detail/main')
    },
    {
      path: '/building/material',
      name: 'building_material',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/material/main')
    },
    {
      path: '/building/price_graph',
      name: 'building_price_graph',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/price_graph/main')
    },
    {
      path: '/building/web_vr',
      name: 'building_web_vr',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/web_vr/main')
    },
    {
      path: '/building/vr',
      name: 'building_vr',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/vr/main')
    },
    {
      path: '/building/video',
      name: 'building_video',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/video/main')
    },
    {
      path: '/building/layout_detail',
      name: 'building_layout_detail',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/layout_detail/main')
    },
    {
      path: '/building/material/preview',
      name: 'building_material_preivew',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/material/preview')
    },
    {
      path: '/building/result',
      name: 'building_result',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/result/main')
    },
    {
      path: '/building/result/search',
      name: 'building_result_search',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/result/search/main')
    },
    {
      path: '/building/review_result/search',
      name: 'building_review_search',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/review_result/search/main')
    },
    {
      path: '/building/lot_detail/main',
      name: 'building_lot_detail',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/lot_detail/main')
    },
    {
      path: '/building/around_facilities/map',
      name: 'building_around_facilities',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/around_facilities/map/main')
    },
    {
      path: '/building/comments/detail',
      name: 'building_comments_detail',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/comments/detail/main')
    },
    {
      path: '/building/discuess_group/main',
      name: 'building/discuess_group/main',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/discuess_group/main')
    },
    {
      path: '/building/value_analysis/main',
      name: 'building/value_analysis/main',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/value_analysis/main')
    },
    {
      path: '/building/add_num/main',
      name: 'building_add_num',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/add_num/main')
    },
    {
      path: '/building/around_facilities/map/main',
      name: 'building/around_facilities/map/main',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/around_facilities/map/main')
    },
    {
      path: '/building/planar_graph/main',
      name: 'building/planar_graph/main',
      component: () => import(/* webpackChunkName: "building" */ '../views/building/planar_graph/main')
    },

]